<template>
  <div>
    <loading :active.sync="is_loading" 
      :can-cancel="true" 
      :is-full-page="true">
    </loading>
    <!-- Navbar -->
    <Navbar/>

    <!-- Sidebar -->
    <SidebarReference/>

    <main id="main" class="main">
        <!-- Breadcomp -->
        <div class="pagetitle">
            <nav style="--bs-breadcrumb-divider: '>';">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item"><a href="#">Struktural</a></li>
                <li class="breadcrumb-item active">{{ name_reference }}</li>
            </ol>
            </nav>

            <div class="row">
                <div class="col-sm-6">
                    <nav style="--bs-breadcrumb-divider: '';">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link to="/sarpras/jenis/index" class="mt-3">
                                    <strong><i class="bi bi-arrow-left"></i></strong>
                                </router-link>
                            </li>
                            <li class="breadcrumb-item">
                                <h1><strong>{{ name_reference }}</strong></h1>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div class="col-sm-6">
                    <div class="float-end">
                        <router-link to="/sarpras/jenis/index" class="btn btn-outline-danger" style="margin-right: 5px;">
                            <i class="fa fa-times"></i>
                            Batal
                        </router-link>
                        <button type="button" v-on:click="update" class="btn btn-primary">
                            <i class="fa fa-save"></i>
                            Simpan
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- END OF BREADCOMP -->

        <section class="section dashboard">
            <div class="row mt-5">
            <!-- Left side columns -->
                <div class="col-lg-12">
                    <div class="row">
                    <!-- Recent Sales -->
                        <div class="col-12">
                            <div class="card recent-sales">

                                <!-- ===== BODY ===== -->
                                <div class="card-body">
                                    <div class="container-fluid">
                                        <div class="card-title">{{ name_page }}</div>
                                        <form action="">
                                            <div class="row mt-3">
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <label for="">Nama Data</label>
                                                        <input type="text" name="name" class="form-control" v-model="name" placeholder="Nama Operator">
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
  </div>

</template>

<script>

    // import
    import axios from 'axios'
    import Loading from 'vue-loading-overlay'

    // Component
    import Navbar from '../../../components/Navbar.vue'
    import SidebarReference from '../../../components/SidebarReference.vue'
    
    export default{
        data(){
          return{
            name_reference: 'Tambah Sarpras',
            name_page: 'Data Operator',

            // Need
            is_fullpage: true,
            is_loading: false,
            token: null,
            name: '',
          }
        },
        mounted(){
            this.token = localStorage.getItem('token');
            
            axios.get(this.$endpoints.sarpras+'supertypes/'+this.$route.params.id+'?token='+this.token)
			.then(response => {
				this.name = response.data.name;

				this.is_loading = false;
			})
			.catch(() => {
				this.is_loading = false;
				alert('there was an error while getting data. please contact developer.');
			})
        },
        components:{
            Navbar,
            SidebarReference,
            Loading,
        },
        methods:{
            update(){
				let fd = this.createFormData({
					name: this.name,
					_method: 'PUT'
				});

				this.is_loading = true;

				axios.post(this.$endpoints.sarpras+'supertypes/'+this.$route.params.id+'?token='+this.token, fd)
				.then(() => {
					this.is_loading = false;
					this.$router.push({path:'/infrastructure/supertype/list'});
				}).catch(() => {
					this.is_loading = false;
					alert('there was an error while updating data. please contact developer');
				})
			}
        }
    }

</script>

<style scoped>
    .btn-primary{
        background-color: #509ee3;    
    }

    .card{
        border-radius: 10px;
    }
    .form-control{
        border-radius: 10px;
    }
    .vue-select2{
        border-radius: 10px;
    }
    .text-red{
        color: #e23232;
    }


</style>